export default {
	AUTHENTICATED: "auth/AUTHENTICATED",
	USER_SAVE: "auth/USER_SAVE"
}